/* Nuuke — cadeau mystère du pack de 6.
   Règle (Samuel, 20/09) : à partir de 6 débardeurs au panier, une ligne « 🎁 Free Mystery Gift » à 0 $
   est ajoutée. En dessous de 6, elle est retirée. Le SKU du cadeau dit au préparateur quoi expédier.
   24/09 : cadeau = 1 sac de lavage en filet (SKU NK-WASH-1PK) → une seule variante utilisée,
   « Mesh Wash Bag » ; compte aussi les débardeurs du produit FR (debardeur-soutien-gorge-integre).

   26/10 (Samuel, « on DONNE vraiment les cadeaux qu'on promet ») — funnel Bubble (HACK #15) :
   la PDP Bubble pose l'attribut de panier « _bub = 1 ». Quand il est là ET qu'il y a 6 débardeurs ou plus,
   le panier contient AUSSI le « 🎁 Free Delicates Wash Bag » (vrai produit, propre SKU, 0 $), et le cadeau
   mystère peut être une autre variante (BUB.mystere) pour ne pas envoyer 2 fois le même sac.
   Tant que BUB.sac vaut null (produit pas encore créé), RIEN ne change : comportement identique à avant.
   Marché FR : jamais de cadeaux Bubble (funnel US seulement).

   Ce n'est PAS un simple ajout : c'est une SYNCHRONISATION rejouée à chaque modification du panier.
   Sinon le cadeau reste quand la cliente repasse au pack de 3 — le bug classique du cadeau offert.

   Anti-boucle : nos propres appels au panier sont marqués (twGiftSync) et n'en redéclenchent pas d'autres. */
(function () {
  if (window.__twGift) return;
  window.__twGift = true;

  var TANK_PRODUCT_IDS = [8263635468397, 15399255900269 /* 22/10 LP 3+3 (the-built-in-bra-tank-3plus3) */, 10307301343341, 8266795516013, 15367947223149, 15367771258989, 15373752303725, 15373758201965]; // The Built-In Bra Tank (US) + Le Débardeur à Soutien-Gorge Intégré (FR) + LP1 + LP2 + 11/10 (Samuel) 3-in-1 Shaper Tank, 3-in-1 Bamboo Boxer Shorts, FrostKnit Shorts
  function estTank(it) { return TANK_PRODUCT_IDS.indexOf(it.product_id) !== -1; }
  var SEUIL = 6;                        // nombre de débardeurs à partir duquel le cadeau est offert

  // Teinte du cadeau selon la couleur dominante des débardeurs. Couleurs mélangées → Medium Nude.
  var VARIANTES = {
    light:  45906528895085, // Light Nude
    medium: 45906528927853, // Medium Nude
    mocha:  45906528960621  // Mocha
  };
  var PAR_COULEUR = {
    'mocha': 'mocha',
    'nude': 'light', 'dusty rose': 'light', 'white': 'light',
    'black': 'medium', 'red': 'medium', 'grey': 'medium', 'olive': 'medium', 'teal': 'medium',
    'cream': 'light', 'light blue': 'medium', 'camel': 'mocha' /* 27/10 nouvelles couleurs */
  };
  var VARIANTES_US = VARIANTES;
  var VARIANTES_FR = {
    light:  50505847144557, // cadeau FR — Surprise mystère
    medium: 50505847177325, // cadeau FR — variante utilisée (sac de lavage)
    mocha:  50505847210093  // cadeau FR — Surprise mystère (C)
  };

  // 26/10 — cadeaux du funnel Bubble. À REMPLIR après création des produits (go Samuel), voir GIFT/PLAN.md.
  var BUB = {
    attribut: '_bub',     // attribut de panier posé ICI quand la page est la PDP Bubble (?view=bubble)
    sac: 67865478332525,  // 26/10 « 🎁 Free Delicates Wash Bag » (produit 15409247584365, UNLISTED, SKU NK-WASH-DLC, 0 $)
    mystere: null         // variante du cadeau mystère pour le funnel Bubble — null = cadeau mystère actuel
  };
  // Vrai si la page affichée est la PDP Bubble (lien du jeu : /products/the-built-in-bra-tank?view=bubble).
  var SUR_BUBBLE = false;
  try { SUR_BUBBLE = /\/products\//.test(location.pathname) && new URLSearchParams(location.search).get('view') === 'bubble'; } catch (e) {}

  // 27/09 (Matteo) : les cadeaux des DEUX marchés sont toujours reconnus comme « cadeau », quel que soit le
  // marché courant. Avant, un cadeau FR resté dans un panier consulté en US (ou l'inverse) n'était pas reconnu,
  // donc jamais retiré : « Free Mystery Gift » et « Cadeau mystère offert » s'affichaient ensemble.
  var TOUTES_VARIANTES = [VARIANTES_US.light, VARIANTES_US.medium, VARIANTES_US.mocha,
                          VARIANTES_FR.light, VARIANTES_FR.medium, VARIANTES_FR.mocha];
  if (BUB.sac) TOUTES_VARIANTES.push(BUB.sac);
  if (BUB.mystere && TOUTES_VARIANTES.indexOf(BUB.mystere) === -1) TOUTES_VARIANTES.push(BUB.mystere);

  var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // 24/09 — marchés FR/BE (/fr-fr, EUR) et Suisse (/fr-ch, CHF) : on offre le cadeau FR
  // (« 🎁 Cadeau mystère offert », prix fixe 0 € / 0 CHF) au lieu du cadeau US. La boutique US
  // (racine « / », USD) garde exactement les variantes et la logique d'avant.
  var MARCHE_FR = /^\/fr-(fr|ch)(\/|$)/.test(racine) ||
    !!(window.Shopify && Shopify.currency && /^(EUR|CHF)$/.test(Shopify.currency.active || ''));
  if (MARCHE_FR) {
    VARIANTES = VARIANTES_FR; // le cadeau ajouté est le FR ; les cadeaux US restants sont retirés (TOUTES_VARIANTES)
  }
  var enCours = false;
  var aRefaire = false;   // une modification est arrivée pendant une synchro : on rejoue après
  var minuteur = null;

  function idDe(item) { return item.variant_id || item.id; }

  function estCadeau(item) {
    return TOUTES_VARIANTES.indexOf(idDe(item)) !== -1;
  }

  // Liste des variantes cadeau que le panier DOIT contenir (chacune en quantité 1).
  function cadeauxVoulus(panier, tanks) {
    if (tanks < SEUIL) return [];
    var bub = !MARCHE_FR && !!BUB.sac &&
      !!(panier.attributes && String(panier.attributes[BUB.attribut] || '') === '1');
    if (!bub) return [VARIANTES.medium]; // 24/09 : sac de lavage → toujours la variante « Mesh Wash Bag »
    return [BUB.mystere || VARIANTES.medium, BUB.sac];
  }

  function changer(corps) {
    return fetch(racine + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-TW-Gift': '1' },
      body: JSON.stringify(corps)
    });
  }

  function prevenirLeTheme() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
      if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
    } catch (e) {}
  }

  async function synchroniser() {
    // Deux modifications rapprochées (vider puis ajouter, ou un ajout suivi d'un upsell) ne doivent
    // pas se perdre : si une synchro tourne déjà, on la rejouera au lieu d'ignorer la demande.
    if (enCours) { aRefaire = true; return; }
    enCours = true;
    try {
      var panier = await (await fetch(racine + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      // PDP Bubble : on marque le panier (_bub=1), recopié sur la commande (note_attributes) pour le mail de confirmation.
      if (SUR_BUBBLE && !MARCHE_FR && !(panier.attributes && String(panier.attributes[BUB.attribut] || '') === '1')) {
        var attrs = {}; attrs[BUB.attribut] = '1';
        await fetch(racine + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-TW-Gift': '1' },
          body: JSON.stringify({ attributes: attrs })
        });
        panier.attributes = panier.attributes || {}; panier.attributes[BUB.attribut] = '1';
      }
      var items = panier.items || [];

      var tanks = 0;
      items.forEach(function (it) { if (estTank(it)) tanks += it.quantity; });

      var voulus = cadeauxVoulus(panier, tanks);
      var cadeaux = items.filter(estCadeau);
      var modifie = false;
      var vus = {};

      // 1) Retirer les cadeaux en trop : variante non voulue, ou doublon d'une variante voulue.
      for (var i = 0; i < cadeaux.length; i++) {
        var v = idDe(cadeaux[i]);
        if (voulus.indexOf(v) === -1 || vus[v]) {
          await changer({ id: String(cadeaux[i].key), quantity: 0 });
          modifie = true;
        } else {
          vus[v] = cadeaux[i];
        }
      }
      // 2) Quantité forcée à la main : on la ramène à 1.
      for (var k in vus) {
        if (vus[k].quantity !== 1) {
          await changer({ id: String(vus[k].key), quantity: 1 });
          modifie = true;
        }
      }
      // 3) Ajouter ceux qui manquent (un seul appel).
      var manquants = voulus.filter(function (id) { return !vus[id]; });
      if (manquants.length) {
        await fetch(racine + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-TW-Gift': '1' },
          body: JSON.stringify({ items: manquants.map(function (id) { return { id: id, quantity: 1 }; }) })
        });
        modifie = true;
      }

      if (modifie) prevenirLeTheme();
    } catch (e) {
      // Un panier qui ne se synchronise pas ne doit jamais bloquer un achat : on laisse passer.
      if (window.console && console.warn) console.warn('[tw-gift]', e);
    } finally {
      enCours = false;
      if (aRefaire) { aRefaire = false; setTimeout(synchroniser, 120); }
    }
  }

  function planifier() {
    clearTimeout(minuteur);
    minuteur = setTimeout(synchroniser, 350);
  }

  // Toute modification du panier, d'où qu'elle vienne (thème, AMP Slide Cart, app d'upsell),
  // passe par une requête /cart/*. On écoute donc fetch plutôt qu'une liste d'événements
  // qui dépendrait du thème ou d'une app.
  var fetchOriginal = window.fetch;
  window.fetch = function (entree, options) {
    var url = '';
    try { url = typeof entree === 'string' ? entree : (entree && entree.url) || ''; } catch (e) {}
    var nous = options && options.headers && (options.headers['X-TW-Gift'] || options.headers['x-tw-gift']);
    var resultat = fetchOriginal.apply(this, arguments);
    if (!nous && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
      resultat.then(function () { planifier(); }).catch(function () {});
    }
    return resultat;
  };

  // Certaines apps passent encore par XMLHttpRequest.
  var openOriginal = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (methode, url) {
    try {
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(String(url))) {
        this.addEventListener('load', function () { planifier(); });
      }
    } catch (e) {}
    return openOriginal.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', synchroniser);
  } else {
    synchroniser();
  }
  window.addEventListener('pageshow', planifier);
})();
